/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df369faf71077508156b33ded1c482c0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { StudioNewLogo } from './logo';
export { StudioNewLogoCS } from './logo-cs';
export { StudioNewIcon } from './icon';
